module.exports = __webpack_public_path__ + "static/media/15UN-Habitat5.8f246d63.jpg";